import { ExportDestinationsMap, PipelineEventType } from "@supernova-studio/model";
import { z } from "zod";
import { DTOExporterPropertyValueMap } from "./exporter-property";
import { DTOExportJob } from "./job";

export const DTOPipelineListQuery = z.object({
  designSystemId: z.string().optional(),
  exporterId: z.string().optional(),
  latestJobsLimit: z.coerce.number().optional(),
});

export const DTOPipeline = z.object({
  id: z.string(),
  name: z.string(),
  eventType: PipelineEventType,
  isEnabled: z.boolean(),
  workspaceId: z.string(),
  designSystemId: z.string(),
  exporterId: z.string(),
  brandPersistentId: z.string().optional(),

  themePersistentId: z.string().optional(),
  themePersistentIds: z.string().array().optional(),

  exporterPropertyValues: DTOExporterPropertyValueMap.optional(),

  ...ExportDestinationsMap.shape,

  latestJobs: DTOExportJob.array(),

  isExporterDeprecated: z.boolean(),
});

export const DTOPipelineListResponse = z.object({
  pipelines: DTOPipeline.array(),
});

export const DTOPipelineResponse = z.object({
  pipeline: DTOPipeline,
});

export type DTOPipelineListQuery = z.infer<typeof DTOPipelineListQuery>;
export type DTOPipeline = z.infer<typeof DTOPipeline>;
export type DTOPipelineResponse = z.infer<typeof DTOPipelineResponse>;
export type DTOPipelineListResponse = z.infer<typeof DTOPipelineListResponse>;
